import { partCategoryLookup, partSubCategoryLookup } from 'utils/lookups';

/* eslint-disable */
export const segmentData: any = [
  {
    "field_map": "partCategory",
    "item_name": "part_category",
    "title": "Part category",
    "lookup": partCategoryLookup,
  },
  {
    "field_map": "partSubCategory",
    "item_name": "part_sub_category",
    "title": "Part sub-category",
    "lookup": partSubCategoryLookup,
  },
]
/* eslint-enable */
